import Vue from 'vue'
import VueRouter from 'vue-router'
import { storage } from '@/store/local'
import routes from './routes'
import { monitorInstall } from '@/utils/monitor'
import monitor from '@/npm/monitor'
import bridge from '@/utils/bridge/wy-bridge'

import { getUA } from '@/utils/index'
const { isNChApp } = getUA()
const CHANNEL_KEY = '_channel_'

Vue.use(VueRouter)

// 重写 VueRouter 的 push 方法，由于路由是hash模式导致 App 里面拦截不到跳转，所以需要重写 push 方法，判断调用 bridge
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function (route, onResolve, onReject) {
  // console.log('push-------', route, onResolve, onReject)
  let path, name, params
  if (typeof route === 'string') {
    path = route
  }
  if (typeof route === 'object') {
    path = route.path
    name = route.name
    params = route.params
  }
  const url = path.startsWith('http') ? path : `${location.origin}/#${path}`
  // console.table({ isNChApp, isAndroid, isIOS, path, url })

  if (isNChApp) {
    bridge.emit('pushWindow', { url })
    return
  }

  if (onResolve || onReject) {
    originalPush.call(this, path, onResolve, onReject)
    return
  }

  originalPush.call(this, { path, name, params }).catch(err => {
    console.warn('originalPush: ', path, err)
  })
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function (location) {
  return originalReplace.call(this, location).catch(err => err)
}
const originalBack = VueRouter.prototype.back
VueRouter.prototype.back = function (e) {
  if (isNChApp) {
    bridge.emit('closeWindow')
    bridge.emit('ncWebReload')
    return
  }
  return originalBack.call(this, e)
}

// 页面路由
const pageRoutes = [
  ...routes,
  {
    path: '/refresh',
    name: 'REFRESH',
    component: () => import('../views/refresh')
  },
  {
    path: '/test',
    name: 'TEST',
    component: () => import('@/views/test'),
    meta: {
      title: '测试',
      loginNo: true
    }
  },
  {
    path: '/dachuan',
    name: 'dachuan',
    component: () => import('@/views/dachuan'),
    meta: {
      title: '大川测试',
      loginNo: true
    }
  },
  {
    path: '/404',
    name: 'notFound',
    component: () => import('../views/404'),
    meta: {
      loginNo: true
    }
  }
]

const router = new VueRouter({
  // 默认hash 模式路径为#开头，history 模式利用 history.pushState API 来完成 URL 跳转而无须重新加载页面。
  // mode: 'history',
  routes: pageRoutes
})

router.beforeEach((to, from, next) => {
  const isLogin = storage.getToken()
  const storeObj = storage.get('entranceData') || {}
  if (to && to.query && to.query[CHANNEL_KEY]) {
    storage.setChannel(to.query[CHANNEL_KEY])
  }

  if (!window.isCreateRouter) { // 首次创建 首页的路由改造
    let home
    if ((to.path === '/entrance/external' && to.query.appType === 'yncmcc') || (to.path !== '/entrance/external' && storeObj.appType === 'yncmcc')) {
      home = {
        path: '/home', // 云南和生活定制H5
        name: 'YUNNAN',
        component: () => import('@/views/aggregate/yunnan'),
        meta: {
          title: '微医医疗服务'
        }
      }
    } else {
      home = {
        path: '/home', // 杭研聚合页首页
        name: 'HOME',
        component: () => import('@/views/home/index'),
        meta: {
          title: '微医医疗服务'
        }
      }
    }
    router.addRoute(home)
    router.addRoute({ path: '*', redirect: '/404' })
    window.isCreateRouter = true
  }

  if (isLogin) {
    if (to.path === '/home' && !to.name) { // 页面刷新
      return next({ path: `/refresh?path=${encodeURIComponent(to.fullPath)}` })
    }
    return next()
  } else {
    if (to.meta.loginNo) { // 不需要登录
      return next()
    } else {
      const url = encodeURIComponent(from.fullPath)
      const path = `/login?target=${url}`
      return next({ path })
    }
  }
})

router.afterEach((to, from, route) => {
  // console.log('from------:', from, 'to------:', to)
  // 设置页面 title，首先取 query参数，再取路由的 meta 配置
  let title = to.query.title || to.meta.title
  if (!title) {
    title = isNChApp ? '一敦健康' : ''
  }
  title && (document.title = title)
  // 如果是 iOS 设备，则使用如下 hack 的写法实现页面标题的更新
  // if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
  //   console.log('iOS 设备=======', navigator.userAgent)
  //   const hackIframe = document.createElement('iframe')
  //   hackIframe.style.display = 'none'
  //   hackIframe.src = '/static/html/fixIosTitle.html?r=' + Math.random()
  //   document.body.appendChild(hackIframe)
  //   setTimeout(_ => {
  //     document.body.removeChild(hackIframe)
  //   }, 300)
  // }

  if (!['/entrance/external'].includes(to.path) && !to.path.startsWith('/entrance/shortChain')) {
    // TODO 本项目路由模式采取的是 hash 模式，所以拼接 url 时需要注意
    const referUrl = `${window.location.protocol}//${window.location.host}/#${from.fullPath}`
    const url = `${window.location.protocol}//${window.location.host}/#${to.fullPath}`

    // 科技埋点
    monitorInstall().then(() => {
      monitor.visit({
        refer_url: from.fullPath === to.fullPath ? '' : referUrl, // 来源
        url
      },
      {
        name: 'event_open_default'
      })
    })
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js